import { put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
    LIST_SHARE_CERTIFICATES,
    LIST_SHARE_CERTIFICATES_SUCCESS,
    LIST_SHARE_CERTIFICATES_FAILURE,
    GET_SHARE_CERTIFICATE,
    GET_SHARE_CERTIFICATE_SUCCESS,
    GET_SHARE_CERTIFICATE_FAILURE,
    SET_SHARE_CERTIFICATE_LIEN,
    SET_SHARE_CERTIFICATE_LIEN_SUCCESS,
    SET_SHARE_CERTIFICATE_LIEN_FAILURE
} from '../../../actions/index.types';
import {
    listShareCertificatesReq,
    getShareCertificateReq,
    setShareCertificateLienReq
} from '../../../../axios/request/SocietyPortal/ShareCertificateReqs/ShareCertificateReqs';

// List
function* listShareCertificatesSaga(action) {
    try {
        const response = yield listShareCertificatesReq(action);
        if (response.success === true) {
            yield put({ type: LIST_SHARE_CERTIFICATES_SUCCESS, data: response });
        } else {
            yield put({ type: LIST_SHARE_CERTIFICATES_FAILURE, data: response.data });
            toast.error(response?.message || "Failed to fetch share certificates");
        }
    } catch (error) {
        yield put({ type: LIST_SHARE_CERTIFICATES_FAILURE, data: error });
        toast.error(error?.message || error?.response?.data?.message || "Something went wrong");
    }
}

// Detail
function* getShareCertificateSaga(action) {
    try {
        const response = yield getShareCertificateReq(action);
        if (response.success === true) {
            yield put({ type: GET_SHARE_CERTIFICATE_SUCCESS, data: response.data });
        } else {
            yield put({ type: GET_SHARE_CERTIFICATE_FAILURE, data: response.data });
            toast.error(response?.message || "Failed to fetch share certificate");
        }
    } catch (error) {
        yield put({ type: GET_SHARE_CERTIFICATE_FAILURE, data: error });
        toast.error(error?.message || error?.response?.data?.message || "Something went wrong");
    }
}

// Lien
function* setShareCertificateLienSaga(action) {
    try {
        const response = yield setShareCertificateLienReq(action);
        if (response.success === true) {
            yield put({ type: SET_SHARE_CERTIFICATE_LIEN_SUCCESS, data: response.data });
            const wasMark = action?.data?.mark === true;
            toast.success(response.message || (wasMark ? "Lien marked" : "Lien released"));
            if (action?.data?.onSuccess) {
                action.data.onSuccess(response.data);
            }
        } else {
            yield put({ type: SET_SHARE_CERTIFICATE_LIEN_FAILURE, data: response.data });
            toast.error(response?.message || "Failed to update lien");
        }
    } catch (error) {
        yield put({ type: SET_SHARE_CERTIFICATE_LIEN_FAILURE, data: error });
        toast.error(error?.message || error?.response?.data?.message || "Something went wrong");
    }
}

export default function* ShareCertificateSaga() {
    yield takeLatest(LIST_SHARE_CERTIFICATES, listShareCertificatesSaga);
    yield takeLatest(GET_SHARE_CERTIFICATE, getShareCertificateSaga);
    yield takeLatest(SET_SHARE_CERTIFICATE_LIEN, setShareCertificateLienSaga);
}
